import * as React from 'react';
import { SVGProps } from 'react';

export const ChristmasBells = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.5127 11.2956C15.5127 12.029 15.803 12.7324 16.3198 13.251C16.8366 13.7696 17.5376 14.0609 18.2685 14.0609C18.9993 14.0609 19.7003 13.7696 20.2171 13.251C20.7339 12.7324 21.0242 12.029 21.0242 11.2956C21.0242 10.5622 20.7339 9.85882 20.2171 9.34022C19.7003 8.82162 18.9993 8.53027 18.2685 8.53027C17.5376 8.53027 16.8366 8.82162 16.3198 9.34022C15.803 9.85882 15.5127 10.5622 15.5127 11.2956Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.1592 26.868L27.206 23.2527C27.522 23.1278 27.7931 22.9056 27.9824 22.6161C28.1717 22.3266 28.2701 21.984 28.2641 21.6348C28.2581 21.2856 28.148 20.9468 27.9489 20.6644C27.7498 20.382 27.4712 20.1698 27.1511 20.0567C26.7069 19.8763 26.306 19.5984 25.9761 19.2422C25.6463 18.8861 25.3954 18.4602 25.2407 17.994L24.033 14.798C23.4758 13.3419 22.3992 12.1617 21.0247 11.5"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.1321 24.4766C24.3432 25.0386 24.3294 25.6643 24.0936 26.2158C23.8578 26.7674 23.4195 27.1996 22.875 27.4176C22.3305 27.6355 21.7244 27.6212 21.1901 27.3778C20.6558 27.1345 20.237 26.682 20.0259 26.1199"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2129 8.70062L21.0135 6.71729"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9852 12.8378C15.6752 13.1439 15.3036 13.3755 14.8968 13.516C14.49 13.6565 14.0582 13.7023 13.6322 13.6504C13.2062 13.5984 12.7966 13.4498 12.4328 13.2153C12.069 12.9808 11.7599 12.6661 11.5276 12.2938C11.343 11.979 11.2227 11.6284 11.1742 11.2637C11.1257 10.8991 11.15 10.528 11.2457 10.1734C11.3413 9.8188 11.5063 9.48816 11.7304 9.20184C11.9544 8.91551 12.2329 8.67956 12.5487 8.50851C13.1704 8.15876 13.8935 8.05216 14.5852 8.2083C15.277 8.36443 15.891 8.77281 16.3145 9.35851"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1431 10.7747L9.27663 10.2193C9.03915 10.1508 8.83094 10.0017 8.68555 9.7961C8.54015 9.59051 8.46604 9.34037 8.47515 9.086V7.95267C8.47817 7.75516 8.43112 7.56027 8.33868 7.38732C8.24624 7.21437 8.11162 7.06936 7.94815 6.96667L6.85024 6.37733C6.68269 6.27748 6.54368 6.1337 6.44728 5.96055C6.35088 5.78741 6.30051 5.59104 6.30128 5.39133V4.13333C6.30128 3.83275 6.41695 3.54449 6.62285 3.33195C6.82875 3.1194 7.10801 3 7.39919 3H9.34251C9.52848 3.00699 9.70967 3.06267 9.86907 3.16179C10.0285 3.26091 10.1609 3.40023 10.2538 3.56667L10.8686 4.53C10.9583 4.67244 11.0779 4.79223 11.2186 4.8805C11.3592 4.96878 11.5173 5.02329 11.6811 5.04L13.0535 5.176C13.2858 5.1998 13.5048 5.29944 13.6785 5.46044C13.8522 5.62145 13.9717 5.83544 14.0196 6.07133L14.4588 8.236"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6813 12.5205C10.799 12.686 9.96947 13.0721 9.26514 13.6451C8.56081 14.218 8.00318 14.9604 7.641 15.8072L6.19175 19.2072C6.01701 19.6657 5.7478 20.0795 5.40277 20.42C5.05775 20.7605 4.64515 21.0196 4.19354 21.1792C3.96329 21.247 3.75039 21.3664 3.57008 21.529C3.38977 21.6917 3.2465 21.8934 3.15052 22.1198C3.0592 22.3249 3.00835 22.5467 3.00094 22.7723C2.99354 22.9979 3.02973 23.2227 3.1074 23.4337C3.18508 23.6447 3.30267 23.8376 3.45334 24.0012C3.604 24.1648 3.78472 24.2958 3.98494 24.3865L14.0309 28.9198C14.3381 29.079 14.6861 29.1342 15.0255 29.0776C15.3648 29.021 15.6783 28.8555 15.9213 28.6046C16.1644 28.3537 16.3247 28.0301 16.3795 27.6798C16.4344 27.3295 16.3809 26.9703 16.2267 26.6532C16.0363 26.2007 15.9436 25.7109 15.955 25.2177C15.9663 24.7245 16.0815 24.2398 16.2926 23.7972L17.632 20.6692C18.2078 19.3834 18.3137 17.9261 17.9303 16.566C17.547 15.2059 16.7001 14.0347 15.546 13.2685"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0228 27.5484C10.7869 28.0985 10.3491 28.5293 9.80548 28.7461C9.26191 28.9629 8.65717 28.9479 8.1243 28.7044C7.59143 28.4609 7.17408 28.0089 6.96406 27.4478C6.75405 26.8867 6.76856 26.2625 7.00442 25.7124"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4716 8.55329L10.8027 6.71729"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.9258 10.5593L22.0237 10.2193C22.2592 10.1487 22.4649 9.99868 22.6082 9.79328C22.7515 9.58789 22.824 9.3389 22.8142 9.086V7.95267C22.8154 7.75488 22.8667 7.56086 22.963 7.38987C23.0593 7.21888 23.1973 7.07689 23.3632 6.978L24.4172 6.37733C24.5831 6.27844 24.7211 6.13645 24.8174 5.96546C24.9137 5.79448 24.965 5.60045 24.9662 5.40267V4.13333C24.9662 3.83275 24.8505 3.54449 24.6446 3.33195C24.4387 3.1194 24.1594 3 23.8682 3H22.0237C21.8397 3.00887 21.6607 3.06543 21.5034 3.16446C21.346 3.26349 21.2154 3.40181 21.1234 3.56667L20.5416 4.51867C20.4507 4.66252 20.3294 4.78317 20.1867 4.87152C20.0441 4.95987 19.8838 5.01361 19.7181 5.02867L18.4226 5.16467C18.1902 5.18846 17.9713 5.2881 17.7975 5.44911C17.6238 5.61012 17.5043 5.82411 17.4564 6.06L16.8745 8.97267"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ChristmasBells;
